// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-theme=\"compact\"]\n  .site-collapse-custom-collapse\n  .site-collapse-custom-panel,\n.site-collapse-custom-collapse .site-collapse-custom-panel {\n  background: #f7f7f7;\n  border-radius: 2px;\n  margin-bottom: 24px;\n  border: 0px;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
